import bulgarianFlag from '@/images/flags/bulgaria_o.png';
import croatianFlag from '@/images/flags/chorwacja_o.png';
import lithuanianFlag from '@/images/flags/litewski_o.png';
import lotvianFlag from '@/images/flags/lotweski_o.png';
import hungarianFlag from '@/images/flags/wegierski_o.png';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
	markContactAsPostalCodePromotion,
	updateContactFromOutbound,
	updateContactFromOutboundBasicInfo,
} from '../../../../API/repositories/contact';
import Loading from '../../../../common/components/Loading';
import { useRequestsContext } from '../../../../common/hooks/requestHook';
import testFlag from '../../../../images/flags/angielski.png';
import czechFlag from '../../../../images/flags/czeski_o.png';
import romanianFlag from '../../../../images/flags/rumunski_o.png';
import slovakFlag from '../../../../images/flags/slowacki_o.png';
import estonianFlag from '../../../../images/flags/estonski_o.png';

import { createSuspicionTicket } from '@/API/repositories/tickets';
import ActionButton from '@/common/components/buttons/ActionButton';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { DISABLED_TOOLTIP } from '@/common/constants/suspicion';
import { validatePhoneForCourier } from '@/common/functions/validatePhoneForCourier';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import { Colors } from '../../../../common/colors/colors';
import Input from '../../../../common/components/Input';
import PopUp from '../../../../common/components/PopUp';
import SelectInput from '../../../../common/components/SelectInput';
import { PHONE_PREFIX } from '@/common/constants/phonePrefix';

const Wrapper = styled.div`
	height: fit-content;
	border-radius: 20px;
	padding: 8px;
	background-color: white;
	display: ${(props) => (props.$isVisible ? 'block' : 'none')};
`;

const Flex = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
	display: flex;
	gap: 10px;
	justify-content: right;
	align-items: center;
`;

const Form = styled.form`
	border: 1px #010b7760 solid;
	border-radius: 8px;
	padding: 4px;
	margin-bottom: 8px;
`;

const PrimaryInfo = ({
	contact,
	setContact,
	market,
	shouldDisableSuspicion,
	onEditAddress,
	selectedCountry,
	setSelectedCountry,
	shouldBeDisplayed,
	handleGetDawnContact = () => {},
}) => {
	const { COUNTRIES } = useCommonDataContext();
	const { translation } = useTranslationContext();

	const [promotionResult, setPromotionResult] = useState();
	const unSaveSet = new Set();

	const { hasUnfilledRequest, makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const fullNameRef = useRef();
	const emailRef = useRef();

	const handlerSaveBasicInfo = async (e) => {
		e.preventDefault();

		const payload = {};

		payload.full_name = fullNameRef.current.value
			? fullNameRef.current.value
			: contact.full_name;
		payload.email = emailRef.current.value
			? emailRef.current.value
			: contact.email;
		payload.country = selectedCountry.value;

		const response = await makeRequest(
			updateContactFromOutboundBasicInfo.bind(null, contact._id, payload),
		);

		handleGetDawnContact();
		if (response.data) {
			unSaveSet.clear();
			setContact(() => response.data);
		}
	};

	const handleCreateSuspicionTicket = async () => {
		const response = await makeRequest(
			createSuspicionTicket.bind(null, contact._id),
		);
		if (!response?.data) {
			return addMessage('Cannot submit', 'error');
		}
		addMessage('Success', 'success');
		return await handleGetDawnContact();
	};

	const handleCheckPromotion = async () => {
		let hasPromotion = {
			region: null,
			message: translation.promNotFound,
			isGood: false,
		};

		try {
			market.regions.forEach((m) => {
				const postalCode = parseInt(contact.postal_code.substring(0, 3));

				const foundCode = m.codes.find(
					(c) => c.from <= postalCode && c.to >= postalCode,
				);

				if (foundCode) {
					hasPromotion.region = m;
					hasPromotion.message =
						translation.promNotAvaiableTitle +
						' ' +
						m.label +
						' ' +
						translation.promNotAvaiable;
				}
			});

			market.promotion.forEach((prom) => {
				const isPromoOK =
					prom.regions.includes(hasPromotion.region._id) &&
					new Date(prom.from) - new Date(contact.created_at) <= 0 &&
					new Date(prom.to) - new Date(contact.created_at) >= 0;

				if (isPromoOK) {
					hasPromotion.isGood = true;
					hasPromotion.message =
						translation.promAvaialbleTitle +
						' ' +
						hasPromotion.region.label.toUpperCase() +
						' ' +
						translation.promAvaiable;
				}
			});
		} catch (e) {
			console.log(e.message);
		}

		const response = await makeRequest(
			markContactAsPostalCodePromotion.bind(
				null,
				contact._id,
				hasPromotion.isGood,
			),
		);

		setContact(() => response.data);
		setPromotionResult(() => hasPromotion);
	};

	const findFalg = (country) => {
		switch (country) {
			case 'ro':
				return romanianFlag;
			case 'sk':
				return slovakFlag;
			case 'ee':
				return estonianFlag;
			case 'cz':
				return czechFlag;
			case 'hu':
				return hungarianFlag;
			case 'lt':
				return lithuanianFlag;
			case 'hr':
				return croatianFlag;
			case 'bg':
				return bulgarianFlag;
			case 'lv':
				return lotvianFlag;
			default:
				return testFlag;
		}
	};

	const handleUnSave = () => {};

	useEffect(() => {
		if (COUNTRIES?.length > 0) {
			setSelectedCountry(() =>
				COUNTRIES.find((country) => country.value === contact.country),
			);
		}
	}, [COUNTRIES]);

	return (
		<Wrapper $isVisible={shouldBeDisplayed}>
			<Flex>
				<div style={{ width: '100px', height: '80px', overflow: 'hidden' }}>
					<img
						src={findFalg(contact.country)}
						alt={contact.country}
						style={{ width: '100%', height: 'auto' }}
					></img>
				</div>
				<h1 style={{ fontSize: '35px' }}>
					{PHONE_PREFIX[contact.country] || '+44'}
					{contact.phone_number
						.match(/.{1,3}/g)
						.map((substring) => substring + ' ')}
					<a
						href={`tel:${
							PHONE_PREFIX[contact.country]
						}${contact?.phone_number?.replaceAll(' ', '')}`}
						style={{ textDecoration: 'none' }}
					>
						<i
							className='fa fa-phone'
							alt='CALL'
							style={{ color: Colors.red }}
						/>
					</a>
				</h1>
			</Flex>
			<Form onSubmit={(e) => handlerSaveBasicInfo(e)}>
				<Input
					onChange={handleUnSave}
					inputRef={fullNameRef}
					name={translation.fullName}
					width={120}
					inputWidth={260}
					margin='6px'
					value={contact.full_name ? contact.full_name : ''}
				/>
				<Input
					margin='6px'
					onChange={handleUnSave}
					inputRef={emailRef}
					name={translation.email}
					width={120}
					inputWidth={260}
					value={contact.email ? contact.email : ''}
				/>
				<SelectInput
					margin='6px'
					width={120}
					name={translation.country}
					selected={selectedCountry}
					setSelected={(value) => {
						setSelectedCountry(value);
					}}
					options={COUNTRIES}
					selectWidth={260}
				/>
				<ButtonWrapper>
					{contact.country === 'cz' && (
						<div>
							<ActionButton
								color={Colors.blue}
								onClick={(e) => handleCheckPromotion(e)}
								disabled={!contact.postal_code}
								defaultText={translation.checkProm}
							/>
						</div>
					)}
					<div>
						<ActionButton
							tooltip={shouldDisableSuspicion ? DISABLED_TOOLTIP : null}
							onClick={() => handleCreateSuspicionTicket()}
							defaultText={translation.suspect}
							color={Colors.red}
							disabled={shouldDisableSuspicion}
						/>
					</div>
					<div>
						<SubmitButton
							style={{
								width: '100px',
								fontSize: '19px',
							}}
							color={Colors.orange}
							text={translation.save}
						/>
					</div>
				</ButtonWrapper>
			</Form>
			<Form onSubmit={(e) => handlerSaveBasicInfo(e)}>
				<Input
					margin='6px'
					onChange={handleUnSave}
					name={translation.postalCode}
					value={contact.postal_code ? contact.postal_code : ''}
					width={120}
					inputWidth={260}
					requiredSign
					disabled
					placeholder=''
					controlled={true}
				/>
				<Input
					margin='6px'
					onChange={handleUnSave}
					width={120}
					inputWidth={260}
					value={contact.city ? contact.city : ''}
					name={translation.city}
					requiredSign
					disabled
					placeholder=''
					controlled={true}
				/>
				<Input
					margin='6px'
					onChange={handleUnSave}
					name={translation.address}
					width={120}
					inputWidth={260}
					value={contact.street ? contact.street : ''}
					requiredSign
					disabled
					placeholder=''
					controlled={true}
				/>
				<Input
					margin='6px'
					onChange={handleUnSave}
					name={translation.phone_number_for_courier}
					width={120}
					inputWidth={260}
					value={contact.phone_number_for_courier}
					placeholder=''
					disabled
					controlled={true}
				/>
				<Input
					margin='6px'
					onChange={handleUnSave}
					name={translation.courierInfo}
					width={120}
					inputWidth={260}
					value={contact.additional_info ? contact.additional_info : ''}
					disabled
					placeholder=''
					controlled={true}
				/>
				<ButtonWrapper>
					<ActionButton
						color={Colors.blue}
						onClick={onEditAddress}
						defaultText={translation.editAddress}
					/>
				</ButtonWrapper>
			</Form>
			{promotionResult && (
				<PopUp setShow={setPromotionResult}>
					<h3
						style={{
							color: promotionResult.isGood ? Colors.green : Colors.red,
							maxWidth: '400px',
							textAlign: 'center',
						}}
					>
						{promotionResult.message}
					</h3>
				</PopUp>
			)}
			{hasUnfilledRequest(updateContactFromOutbound, createSuspicionTicket) && (
				<Loading />
			)}
		</Wrapper>
	);
};

export default PrimaryInfo;
